var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("div", { staticClass: "modal", class: { "is-active": _vm.modal } }, [
        _c("div", { staticClass: "modal-background" }),
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "box is-centered" }, [
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(
                  "\n            ¿Estas seguro de cancelar este recibo de salario?\n          "
                )
              ]),
              _c("div", { staticClass: "control is-centered" }, [
                _c("div", { staticClass: "field is-grouped" }, [
                  _c("p", { staticClass: "control" }, [
                    _c(
                      "a",
                      {
                        staticClass: "button is-success",
                        class: { "is-loading": _vm.isLoading },
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.cancelById }
                      },
                      [
                        _vm._m(0),
                        _c("span", [
                          _vm._v("\n                    Sí\n                  ")
                        ])
                      ]
                    )
                  ]),
                  _c("p", { staticClass: "control" }, [
                    _c(
                      "a",
                      {
                        staticClass: "button is-danger",
                        class: { "is-loading": _vm.isLoading },
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.onCloseModal }
                      },
                      [
                        _vm._m(1),
                        _c("span", [
                          _vm._v("\n                    No\n                  ")
                        ])
                      ]
                    )
                  ])
                ])
              ])
            ])
          ])
        ]),
        _c("button", {
          staticClass: "modal-close is-large",
          attrs: { "aria-label": "close" },
          on: { click: _vm.onCloseModal }
        })
      ]),
      _c("h1", { staticClass: "title is-4 has-text-primary" }, [
        _vm._v("\n    Recibos de Salario\n  ")
      ]),
      _c("AppPagination", {
        staticClass: "is-centered",
        attrs: {
          "current-page": _vm.currentPage,
          "buttons-max": _vm.buttonsMax,
          "pages-total": _vm.totalPages
        },
        on: { change: _vm.goToPage }
      }),
      _c("table", { staticClass: "table is-fullwidth" }, [
        _vm._m(2),
        _c(
          "tbody",
          [
            _vm.isLoading
              ? _c("tr", [_vm._m(3)])
              : [
                  _vm.invoices.length === 0
                    ? _c("tr", [
                        _c(
                          "td",
                          { staticClass: "empty", attrs: { colspan: "7" } },
                          [_vm._v("\n            Sin datos\n          ")]
                        )
                      ])
                    : _vm._l(_vm.invoices, function(invoice, index) {
                        return _c("tr", { key: index }, [
                          _c("td", [
                            _vm._v(_vm._s(invoice.voucherConsecutive))
                          ]),
                          _c("td", [_vm._v(_vm._s(invoice.receiverName))]),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm._f("toHumanDate")(invoice.voucherDate))
                            )
                          ]),
                          _c("td", [
                            _vm._v(_vm._s(_vm.statusSaleNote(invoice)))
                          ]),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("toCurrency")(
                                  invoice.voucherTotal,
                                  invoice.voucherCurrency
                                )
                              )
                            )
                          ]),
                          _c("td", [
                            _c(
                              "div",
                              { staticClass: "actions" },
                              [
                                invoice.operation.status !== 201
                                  ? _c(
                                      "AppRadialMenu",
                                      {
                                        attrs: {
                                          size: 36,
                                          "item-size": 48,
                                          radius: 80,
                                          "angle-restriction": 180,
                                          rotate: 270
                                        }
                                      },
                                      [
                                        _c(
                                          "AppRadialMenuItem",
                                          {
                                            staticClass:
                                              "tooltip is-tooltip-primary has-background-primary has-text-white",
                                            attrs: {
                                              "data-tooltip":
                                                "Detalle de recibo de salario"
                                            }
                                          },
                                          [
                                            _c(
                                              "RouterLink",
                                              {
                                                staticClass: "action-option",
                                                attrs: {
                                                  to: {
                                                    name: "SalaryReceiptDetail",
                                                    params: { uuid: invoice.id }
                                                  }
                                                }
                                              },
                                              [
                                                _c("BIcon", {
                                                  staticClass:
                                                    "action-option-icon",
                                                  attrs: { icon: "eye" }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "AppRadialMenuItem",
                                          {
                                            staticClass:
                                              "tooltip is-tooltip-success has-background-success has-text-white",
                                            attrs: {
                                              "data-tooltip": "Reenviar PDF"
                                            }
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "action-option",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.sendEmail(
                                                      invoice.id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("BIcon", {
                                                  staticClass:
                                                    "action-option-icon",
                                                  attrs: { icon: "send" }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _c(
                                          "AppRadialMenuItem",
                                          {
                                            staticClass:
                                              "tooltip is-tooltip-info has-background-info has-text-white",
                                            attrs: {
                                              "data-tooltip": "Descargar PDF"
                                            }
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "action-option",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.download(
                                                      "pdf",
                                                      invoice.id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("BIcon", {
                                                  staticClass:
                                                    "action-option-icon",
                                                  attrs: {
                                                    icon: "cloud-download"
                                                  }
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "close-label"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      pdf\n                    "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _c(
                                          "AppRadialMenuItem",
                                          {
                                            staticClass:
                                              "tooltip is-tooltip-danger has-background-danger has-text-white",
                                            attrs: {
                                              "data-tooltip":
                                                "Cancelar recibo de salario"
                                            }
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "action-option",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.cancelInvoice(
                                                      invoice.id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("BIcon", {
                                                  staticClass:
                                                    "action-option-icon",
                                                  attrs: { icon: "cancel" }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                invoice.operation.status == 201
                                  ? _c(
                                      "div",
                                      { staticClass: "buttons" },
                                      [
                                        _c(
                                          "RouterLink",
                                          {
                                            staticClass:
                                              "button is-info tooltip is-tooltip-info",
                                            attrs: {
                                              "data-tooltip":
                                                "Detalle de recibo de salario",
                                              to: {
                                                name: "SalaryReceiptDetail",
                                                params: { uuid: invoice.id }
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "icon" },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "material-icons"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      remove_red_eye\n                    "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ])
                      })
                ]
          ],
          2
        )
      ]),
      _c("AppPagination", {
        staticClass: "is-centered",
        attrs: {
          "current-page": _vm.currentPage,
          "buttons-max": _vm.buttonsMax,
          "pages-total": _vm.totalPages
        },
        on: { change: _vm.goToPage }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon is-smal" }, [
      _c("i", { staticClass: "material-icons" }, [
        _vm._v("\n                      check\n                    ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon is-smal" }, [
      _c("i", { staticClass: "material-icons" }, [
        _vm._v("\n                      clear\n                    ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Folio")]),
        _c("th", [_vm._v("Nombre")]),
        _c("th", [_vm._v("Fecha")]),
        _c("th", [_vm._v("Status")]),
        _c("th", [_vm._v("Total")]),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "is-loading", attrs: { colspan: "8" } }, [
      _c("a", { staticClass: "button is-loading is-fullwidth" }, [
        _vm._v("\n            Cargando..\n          ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }